<template>
  <div class="money-task block-base">
    <div class="title">做任务赚现金</div>

    <!-- 分享给好友区域 -->
    <div class="share-section" v-if="shareSlots.length">
      <div class="share-title" @click="showRules">邀请好友必得大额现金<span class="ruls-icon"></span></div>
      <div class="share-users-container">
        <div class="share-users" :class="{ 'center-layout': shareSlots.length <= 5 }">
          <div
            class="user-avatar"
            v-for="(slot, index) in shareSlots"
            :key="index"
            @click="handleShare(slot)"
          >
            <template v-if="slot.shared">
              <div class="avatar-border">
                <img class="avatar-image" :src="slot.avatar" :alt="slot.nickname">
              </div>
              <div class="user-name">{{ formatNickname(slot.nickname) }}</div>
            </template>
            <template v-else>
              <div class="add-user">
                <div class="add-user-containt"></div>
              </div>
              <div class="can-get-num">{{ getShareText(slot.giftQty) }}</div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- 分享组件 -->
    <MShare
      v-model="showShare"
      title="分享给朋友"
      :content="shareContent"
      @share="handleShareType"
    />

    <!-- 任务列表 -->
    <div class="task-list" mg-stat-show="flag=610" mg-stat-lob="smod=cash_task">
      <div
        class="task-item"
        :class="{ completed: task.completed && task.received,'mango-card-task': task.isMangoCard }"
        v-for="(task, index) in displayTasks"
        :key="index"
      >
        <div class="task-info">
          <div class="task-header">
            <div class="task-name">
              {{ task.name }}
              <img src="../../assets/v2/cash/mango-card-logo.png" v-if="task.isMangoCard" class="mango-card-logo">
            </img>
            </div>
          </div>
          <div class="task-reward">
              <div class="coin-icon"></div>
              <span class="reward-text">
                <span class="prefix">最高得</span>
                <span class="amount">{{ task.reward }}元</span>
              </span>
              <span class="task-desc">{{ task.description }}</span>
            </div>
        </div>
        <div class="task-action"
          :class="{
            'to-complete': !task.completed,
            'to-receive': task.completed && !task.received,
            'received': task.completed && task.received
          }"
          @click="handleTaskAction(task)"
        >
          {{ getActionText(task) }}
        </div>
      </div>
    </div>

    <!-- 展开/收起按钮 -->
    <div class="expand-btn" @click="toggleExpand" v-if="this.tasks.length > 2">
      {{ isExpanded ? '收起' : '展开' }}
      <img :src="isExpanded ? foldUpIcon : foldDownIcon" alt="fold">
    </div>

    <!-- 邀请规则弹窗 -->
    <Dialog
      v-model="inviteRulesDialogVisible"
      title="如何赚25元？"
      :confirmText="onlyShowRules ? '我知道了' : '立即邀请'"
      @confirm="onInviteRulesConfirm"
      @close="onInviteRulesClose"
      :append-to-body="true"
      content-class="invite-rules-tip-content"
    >
      <div>
        <div class="step-item">
          <div class="step-nums">第一步</div>
          <div class="step-content">邀请好友下载芒果TV并<span class="impt">观看1分钟</span>视频，发放部分奖励</div>
        </div>
        <div class="step-item">
          <div class="step-nums">第二步</div>
          <div class="step-content">您的好友在第2-7天<span class="impt">观看2个</span>及以上视频且总时长<span class="impt">大于10分钟</span>，即可完成助力</div>
        </div>
        <div class="step-item">
          <div class="step-nums">第三步</div>
          <div class="step-content">助力完成后，将发放剩余全部奖励，您可在<span class="impt">奖励中心-现金明细</span>里查看</div>
          <div class="step-content">成功邀请5位好友助力，<span class="impt">必得25元</span>！</div>
        </div>
      </div>
    </Dialog>

    <!-- 为好友助力中弹窗 -->
    <Dialog
      v-model="modalManager.state.visibleMap.b"
      :title="`为好友${nickName}助力中`"
      :showFooter="false"
      @close="onHelpingClose"
      :append-to-body="true"
      content-class="helping-tip-content"
    >
      <div>
        <div class="helping-item">
          您在第2-7天内<span class="impt">观看2个及以上视频</span>且总时长<span class="impt">大于10分钟</span>，即可为好友完成助力
        </div>
        <div class="tip-switch" @click="switchTip">
          <div class="switch-icon" :class="helpTipStatus === TIP_STATUS.on ? 'selected' : 'unselected'"></div>
          <div class="txt">开启消息提醒</div>
        </div>
      </div>
    </Dialog>

    <!-- 朋友助力成功弹窗 -->
    <CongratulationDialog
      v-model="modalManager.state.visibleMap.e"
      title="新的好友为你助力"
      confirmText="立即收下"
      @confirm="onFriendHelpConfirm"
      @close="onFriendHelpClose"
      :append-to-body="true"
      content-class="share-result-content"
    >
      <div>
        <div class="amount">{{ helpAmount }}<span>元</span></div>
      </div>
    </CongratulationDialog>

    <!-- 为好友助力成功 -->
    <CongratulationDialog
      v-model="modalManager.state.visibleMap.f"
      title="为好友助力成功"
      confirmText="去赚现金"
      @confirm="onHelpSuccessConfirm"
      @close="onHelpSuccessClose"
      :append-to-body="true"
      content-class="share-result-content"
    >
      <div>
        <div class="help-text">
          <div>全部现金奖励已发放至好友账户中。您也可以做任务赚现金，提现秒到账</div>
        </div>
      </div>
    </CongratulationDialog>

    <!-- 现金获取成功弹窗 -->
    <CongratulationDialog
      v-model="moneyGetVisible"
      title="成功获得"
      confirmText="立即收下"
      @confirm="onMoneyGetDialogConfirm"
      @close="onMoneyGetDialogClose"
    >
      <div class="money-get-content">
        <div class="amount">{{ moneyGetNum }}<span>元</span></div>
      </div>
    </CongratulationDialog>

    <!-- 低版本提醒 -->
    <versionDialog ref="versionDialog" />
  </div>
</template>

<script>
import foldUpIcon from '../../assets/v2/fold_up.png'
import foldDownIcon from '../../assets/v2/fold_down.png'
import MShare from '../share/index.vue'
import { mapState, mapGetters } from 'vuex'
import { AppApi } from '@/utils/appApi'
import { genInviteCode, acceptInvite, getActivityList, receiveTaskCash, inviteSubscribe, inviteGrossIncome, recentInviters } from '@/request/cash';
import { createWord } from '@/request/index';
import Dialog from '@/v2-components/dialog/index.vue';
import { taskMixin, loginMixin } from '@/utils/mixin';
import TASK_MAP from '../task-list/config';
import CongratulationDialog from '@/v2-components/dialog/congratulation.vue';
import versionDialog from '@/v2-components/d-version-tips';
import { EventBus } from '@/utils/eventBus';
import { setStore, getStore } from '@/utils/mUtil';
import modalManager from '@/utils/modalManager';
import Utils from '../../utils/utils'

const TIP_STATUS = {
  'on': 1, // 已开启
  'off': 0, // 未开启
}

const HELP_STATUS = {
  'none': 0, // 无助力对象
  'doing': 1, // 助力中
  'done': 2, // 助力任务已经完成
}

export default {
  mixins: [taskMixin, loginMixin],
  components: {
    MShare,
    Dialog,
    CongratulationDialog,
    versionDialog,
  },
  props: {
    inviteSettings: {
      type: Array,
      default: () => []
    },
    taskSign: {
      type: String,
    },
    inviteTaskId: {
      type: Number,
    }
  },
  data() {
    return {
      onlyShowRules: false,
      helpAmount: '0.0',
      helpFriInfo: {},
      TIP_STATUS,
      helpTipStatus: HELP_STATUS.off,
      HELP_STATUS,
      helpStatus: HELP_STATUS.none,
      helpingDialogVisible: true,
      inviteRulesDialogVisible: false,
      onInviteRulesDialogClose: null,
      inviteCode: '',
      shareContent: '',
      isExpanded: false,
      foldUpIcon,
      foldDownIcon,
      moneyGetVisible: false,
      moneyGetNum: 0,
      shareSlots: [
      ],
      tasks: [],
      showShare: false
    }
  },
  async mounted() {
    this.$nextTick(() => {
      // 获取现金任务
      this.getMoneyTaskInfo()
    });

    // 检查路由参数中是否有 inviteCode
    const inviteCode = this.$route.query.inviteCode;
    if (inviteCode) {
      // 检查版本，如果返回 false 表示版本过低，不继续执行
      if (!this.$refs.versionDialog.checkVersion()) {
        return;
      }
      if(this.isNoneCashVer || await Utils.isSpecialVersion()){ //不支持现金提现的端 apad首次进入取不到store
        return 
      }

      this.$nextTick(() => {
        this.excuteAcceptInvite(inviteCode);
      });
    }
    // 监听页面重新显示事件
    EventBus.$on('page-reshow', this.getMoneyTaskInfo)
  },
  beforeDestroy() {
    // 移除事件监听
    EventBus.$off('page-reshow', this.getMoneyTaskInfo)
  },
  computed: {
    modalManager() {
      return modalManager;
    },
    ...mapState(['isMGTV', 'isNoneCashVer']),
    ...mapGetters(['isLogin']),
    displayTasks() {
      return this.isExpanded ? this.tasks : this.tasks.slice(0, 2)
    },
    nickName() {
      if (typeof this.helpFriInfo.nickname === 'string') {
        if (this.helpFriInfo.nickname.length > 6) {
          return this.helpFriInfo.nickname.slice(0, 6) + '...';
        }
      }
      return this.helpFriInfo.nickname;
    },
  },
  watch: {
    inviteSettings: {
      handler(newSettings) {
        if (newSettings && newSettings.length > 0) {
          // 转换数据结构
          this.shareSlots = newSettings.map(setting => {
            if (setting.inviteUser) {
              return {
                shared: true,
                avatar: setting.inviteUser.photo,
                nickname: setting.inviteUser.nickname,
              }
            } else {
              return {
                shared: false,
                giftQty: setting.giftQty,
                taskId: this.inviteTaskId,
              }
            }
          });

          this.getHelpAmount(newSettings);
        }
      },
      immediate: true
    },
    inviteTaskId: {
      handler(newVal) {
        // 拉取最近助力对象，助力阶段不拉取，助力完成后拉取
        if (newVal && this.$route.query.inviteCode === undefined) {
          this.getRecentHelpedInfo();
        } else if (newVal && this.$route.query.inviteCode && this.fetchCalled === false) {
          this.getRecentHelpedInfo();
          this.fetchCalled = true;
        }
      },
    },
    inviteRulesDialogVisible: {
      handler(newVal) {
        // 最近助力对象
        if (newVal) {
          this.reportCVRulesPop();
        }
      },
    }
  },
  methods: {
    async getRecentHelpedInfo() {
      try {
        const { data, code, msg } = await recentInviters({
          taskId: this.inviteTaskId,
        });

        if (code === 200) {
          if (data?.popUp) {
            switch (data.stepStatus) {
              case HELP_STATUS.doing: // 助力中
                this.helpFriInfo = data.inviter ?? {};
                modalManager.add('b'); // 观影助力中弹窗
                this.helpTipStatus = data.subscribeStatus;
                this.helpStatus = data.stepStatus;
                break;
              case HELP_STATUS.done: // 助力完成
                modalManager.add('f'); // 观影助力成功弹窗
              default:
                break;
            }
          }
        } else {
          this.$toast(msg);
        }
      } catch (error) {
        console.error(error);
        this.$toast(error);
      }
    },
    async switchTip() {
      try {
        const { code, msg } = await inviteSubscribe({
          taskId: this.inviteTaskId,
          taskSign: this.taskSign,
          subscribe: this.helpTipStatus === TIP_STATUS.on ? 2 : 1,
        });

        if (code === 200) {
          this.helpTipStatus = this.helpTipStatus === TIP_STATUS.on ? TIP_STATUS.off : TIP_STATUS.on;
        } else {
          this.$toast(msg);
        }
      } catch (error) {
        console.error(error);
        this.$toast(error);
      }
    },
    showRules() {
      this.onlyShowRules = true;
      this.inviteRulesDialogVisible = true;
      this.showRulesReport();
    },
    showRulesReport() {
      try {
        MgStat.send(
          'click',
          {
          },
          {
            cntp: 'score_newHome',
            mod: 'ask_icon',
            cont: '点击问号',
          }
        )
      } catch (error) {
        console.error('点击问号 上报失败');
      }
    },
    reportCVRulesPop() {
      try {
        MgStat.send('cv',
          {
          },
          {
            mod: 'c_scorerulepop'
          }
        )
      } catch (error) {
        console.error('c_scorerulepop 曝光 上报失败');
      }
    },
    onInviteRulesConfirm() {
      this.inviteRulesDialogVisible = false;

      if (!this.onlyShowRules) {
        this.inviteRulesconfirmReport();
        // 调用 Promise 的 resolve
        if (this.onInviteRulesDialogClose) {
          this.onInviteRulesDialogClose();
          this.onInviteRulesDialogClose = null;
        }
      } else {
        this.onlyShowRules = false;
      }
    },
    inviteRulesconfirmReport() {
      try {
        MgStat.send(
          'click',
          {
          },
          {
            cntp: 'score_newHome',
            mod: 'now_invite',
            cont: '点击立即邀请',
          }
        )
      } catch (error) {
        console.error('点击立即邀请 上报失败');
      }
    },
    onInviteRulesClose() {
      this.inviteRulesDialogVisible = false;
      if (this.onlyShowRules) {
        this.onlyShowRules = false;
      }
      // 调用 Promise 的 resolve
      // if (this.onInviteRulesDialogClose) {
      //   this.onInviteRulesDialogClose();
      //   this.onInviteRulesDialogClose = null;
      // }
    },
    onMoneyGetDialogConfirm() {
      this.moneyGetVisible = false;
    },
    onMoneyGetDialogClose() {
      this.moneyGetVisible = false;
    },
    onFriendHelpClose() {
      modalManager.close('e');
    },
    onHelpSuccessClose() {
      modalManager.close('f');
    },
    onHelpingClose() {
      modalManager.close('b');
    },
    refreshInfo() {
      this.$store.dispatch('queryCashUserInfo');
    },
    // 分转元
    formatMoney(num = 0, n = 1) {
      const res = (num / 100).toFixed(n);
      return res[res.length - 1] === '0' ? res.slice(0, -1) : res;
    },
    // 处理用户助力成功信息
    getHelpAmount(tasks) {
      let totalHelpAmount = 0;

      tasks.forEach(setting => {
        if (setting.inviteUser?.readReceipt === 0) {
          // 记录好友助力金额信息 readReceipt为0 表示当前助力信息未曾展示给用户
          totalHelpAmount += setting.giftQty;
        }
      });

      this.getWatchVideoIncome().then((watchIncome) => {
        const total = Number(watchIncome ?? 0) + totalHelpAmount;
        if (total !== 0) {
          this.helpAmount = this.formatMoney(total, 2);
          modalManager.add('e'); // 展示好友助力成功弹窗
        }
      }).catch(() => {
        // 获取视频观影接口失败后，不计算观影奖励
        if (totalHelpAmount !== 0) {
          this.helpAmount = this.formatMoney(totalHelpAmount, 2);
          modalManager.add('e'); // 展示好友助力成功弹窗
        }
      });
    },
    // 视频观影奖励金额
    async getWatchVideoIncome() {
      try {
        const { code, data, msg } = await inviteGrossIncome(
          {
            taskId: this.inviteTaskId
          }
        );

        if (code === 200) {
          return data?.amount ?? 0;
        } else {
          this.$toast(msg);
        }
      } catch (error) {
        console.error(error);
        this.$toast(error);
      }
    },
    async getMoneyTaskInfo() {
      try {
        const { data, code, msg } = await getActivityList({
          listKey: 'CREDIT_CASH_KEYS',  // 拉取签到任务和邀约任务
          returnAll: 1,
        });

        if (code === 200) {
          // 先转换任务数据
          const tasks = data.TaskInfos.map(item => {
            const taskSetting = item.taskSettings[0];
            return {
              name: item.taskTitle,
              description: item.taskDescription,
              reward: this.formatMoney(taskSetting.giftQty, 2),
              completed: item.userTaskStatus === 2,
              received: item.profit?.profitState === 2,
              url: item.url,
              taskId: item.taskId,
              profit: item.profit,
              thirdExchange: item.thirdExchange,
              isMangoCard: item.thirdExchange?.isMangoCard,
              taskSign: item.taskSign,
            };
          });

          // 按状态排序：已完成未领取 -> 未完成 -> 已领取
          tasks.sort((a, b) => {
            // 定义状态优先级：已完成未领取 = 0，未完成 = 1，已领取 = 2
            const getStatusPriority = (task) => {
              if (task.completed && !task.received) return 0;  // 已完成未领取
              if (!task.completed) return 1;  // 未完成
              return 2;  // 已领取
            };

            return getStatusPriority(a) - getStatusPriority(b);
          });
          
          this.tasks = tasks;
        } else {
          console.error(msg);
        }
      } catch (error) {
        this.$toast('网络错误，请刷新页面重试');
        console.log('获取现金任务信息失败:', error)
      }
    },
    async excuteAcceptInvite(inviteCode) {
      try {
        if (!this.isLogin) {
           MgtvApi.login(async (data) => {
            // 登录成功后需要先设置USERINFO到vuex中，否则将从cookie中读取，但cookie的设置是异步的，不可控
            let USERINFO = {};
            try {
              USERINFO = JSON.parse(data);
            } catch (error) {
              console.log('登录后解析用户信息数据失败：', data);
            }

            this.$store.commit('setUserInfo', USERINFO);

            const { code, msg } = await acceptInvite({ inviteCode });

            this.acceptInviteCallback(code, msg);
           });
        } else {
          const { code, msg } = await acceptInvite({ inviteCode });

          this.acceptInviteCallback(code, msg);
        }

      } catch (error) {
        this.$toast('网络错误，请刷新页面重试');
        console.error('好友助力接口失败: ', error);
      }
    },
    tryFetchRecentHelpedInfo() {
      // 由于inviteTaskId是通过接口获取，在执行getRecentHelpedInfo请求时依赖该参数，所以需要等待明确inviteTaskId有结果后再发起，故做此标记
      if (this.inviteTaskId) {
        this.getRecentHelpedInfo();
      } else {
        this.fetchCalled = false;
      }
    },
    acceptInviteCallback(code, msg) {
      switch (code) {
        case 200:
          this.tryFetchRecentHelpedInfo(); // 查询助力对象
          break;
        case 2005:
          this.$toast('您今天已经助力过啦');
          break;
        case 2009:
          this.$toast('当前助力已过期');
          break;
        case 2101:
          this.$toast('助力失败，您不是新用户哦');
          break;
        case 2006:
          this.$toast('对方好友邀请次数已达上限');
          break;
        default:
          this.$toast(msg);
          break;
      }
    },
    onHelpSuccessConfirm() {
      modalManager.close('f');
      this.refreshInfo();
    },
    onFriendHelpConfirm() {
      modalManager.close('e');
      this.refreshInfo();
    },
    formatNickname(nickname) {
      return nickname || '未知用户'
    },
    getShareText(num) {
      // return `必得${this.formatMoney(num, 2)}元`;
      return `必得5元`;
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded
    },
    handleTaskAction(task) {
      // 检查版本，如果返回 false 表示版本过低，不继续执行
      if (!this.$refs.versionDialog.checkVersion()) {
        return;
      }

      const wrappedHandler = this.$wrapClick(() => {
        if (task.completed === false) {
          this.doMoneyTask(task);

          // 去完成状态上报
          this.reportTaskClick({
            taskid: task.taskId,
            taskidtype: 2,
            status: 0,
          });
        } else if (task.received === false) {
          this.receiveMoney(task);

          // 去领取状态上报
          this.reportTaskClick({
            taskid: task.taskId,
            taskidtype: 2,
            status: 1,
          });
        }
      });

      wrappedHandler();
    },
    async receiveMoney(task) {
      try {
        const { data, code, msg } = await receiveTaskCash({
          profitId: task.profit?.profitId,
          taskId: task.taskId,
        });
        if (code === 200) {
          this.moneyGetNum = this.formatMoney(data.giftQty, 2);
          this.moneyGetVisible = true;
          // v2 更新积分信息
          this.$store.dispatch('queryCashUserInfo');
          // 更新任务
          this.getMoneyTaskInfo();
        } else {
          this.$toast(msg);
        }
      } catch (error) {
        console.error('领取失败：', error);
      }
    },
    reportTaskClick({taskid, taskidtype, status}) {
      try {
        MgStat.send(
          'click',
          {
            taskid,
            taskidtype,
            status,
          },
          {
            cntp: 'score_newHome',
            mod: 'task',
            cont: '点击任务',
          }
        )
      } catch (error) {
        console.error('score_newHome task 点击任务 上报失败');
      }
    },
    rulesTip() {
      return new Promise((resolve) => {
        if (!getStore('inviteRulesDialogFlag')) {
          // 显示弹窗
          this.inviteRulesDialogVisible = true;
          setStore('inviteRulesDialogFlag', 1);
          // 保存 resolve 回调
          this.onInviteRulesDialogClose = () => {
            resolve();
          };
        } else {
          resolve();
        }
      });
    },
    async handleShare(task) {
      // 检查版本，如果返回 false 表示版本过低，不继续执行
      if (!this.$refs.versionDialog.checkVersion()) {
        return;
      }

      // 分享完成的点击无反应
      if (task.shared) {
        let hasFinishedAllShare = this.inviteSettings.every(item => item.inviteUser);

        // 邀请次数满后，用户点击好友分享模块任意位置，弹出Toast提示“今日邀请次数已用完，请明日再来”
        if (hasFinishedAllShare) {
          this.$toast('今日邀请次数已用完，请明日再来');
        }
        return;
      };

      this.reportTaskClick({
        taskid: task.taskId,
        taskidtype: 1,
        status: 0,
      });

      const wrappedHandler = this.$wrapClick(async() => {
        await this.rulesTip();

        try {
          const { code, data, msg } = await genInviteCode({ taskId: task.taskId, });

          if (code === 200) {
            this.inviteCode = data.inviteCode;

            // 口令
            await this.generateWord();

            this.showShare = true;

            // 控件曝光事件
            try {
              MgStat.send(
                'cv',
                {},
                {
                  mod: 'c_scoresharepop',
                }
              )
            } catch (error) {
              console.error('c_scoresharepop 控件曝光事件 上报失败');
            }

            await AppApi.sendToClipboard({
              content: this.shareContent,
            });
          } else {
            this.$toast(msg);
          }
        } catch (error) {
          console.error('获取邀请码失败：', error);
        }
      });

      wrappedHandler();
    },
    /**
     * 生成口令
     */
    async generateWord() {
        const url = 'https://app.mgtv.com/credits/v2.html#/';
        const params = '?inviteCode=' + this.inviteCode;

        try {
          const { code, data, msg } = await createWord({
            url: decodeURIComponent(url) + params,
            pic: 'https://ossimg.hitv.com/platform_oss/D2F8A9DDA2624370B5BA689B4BCB8F7C.png',
          });

          if (code === 200) {
            console.log('word', data);
            this.shareContent = `复制这段信息@${data.sn}@ CZ0001 打开【芒果TV】参与任务中心现金激励活动，每天领现金，提现秒到账！`
          } else {
            this.$toast(msg);
          }
        } catch (error) {
          console.error('口令生成失败：', error);
        }
    },
    async handleShareType(type, rch) {
      try {
        await AppApi.shareTo({
          type,
          style: 0,
          title: '奖励中心领现金秒到账！',
          shareUrl: location.origin + location.pathname + '#/zhuli' + '?inviteCode=' + this.inviteCode + `&rch=${rch}`,
          shareDesc: '每天开幸运盲盒，最高可得10元现金奖励！',
          shareIcon: 'https://ossimg.hitv.com/platform_oss/0A666DA9702845268AD8C0FAF59ABB4A.png',
        })
        this.showShare = false
      } catch (error) {
        console.log('分享失败:', error)
      }
    },
    getActionText(task) {
      if (!task.completed) return TASK_MAP[task.taskId]?.btn || '去完成';
      if (!task.received) return '领取';
      return '已领取';
    }
  }
}
</script>

<style scoped lang="less">
  @import './index.less';
</style>
